// extracted by mini-css-extract-plugin
export default {"root":"WelcomeOnBoardPage_root__Jzgb6","cards":"WelcomeOnBoardPage_cards__t+uZg","card":"WelcomeOnBoardPage_card__Se2ao","img":"WelcomeOnBoardPage_img__bZM8l"};